<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- setores -->
        <th
          scope="row"
          class="px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <div class="text-base font-semibold">
            {{ row["name"] }}
          </div>
        </th>

        <!-- integrantes - count -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div class="text-base font-semibold">
            {{ JSON.parse(row["participantes"]).length }}
          </div>
        </td>

        <!-- participantes - modal-->
        <!-- <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div class="text-base font-semibold">
            {{
              JSON.parse(row["participantes"])
            }}
          </div>
        </td> -->

        <!-- ações -->
        <td class="py-4 sticky -right-1 bg-white">
          <div class="flex justify-center font-medium">
            <!-- Ver documento -->
            <a
              title="Alterar setor"
              class="text-yellow-600 mr-1 cursor-pointer"
              @click="editSector(row['id'])"
            >
              <component :is="PhPencilLine" class="h-7 w-7 md:h-6 md:w-6" />
            </a>

            <!-- Remover documento -->
            <a
              title="Remover setor"
              class="text-red-600 ml-1 cursor-pointer"
              @click="deleteDoc(row['id'])"
            >
              <component :is="PhTrash" class="h-7 w-7 md:h-6 md:w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { PhPencilLine, PhTrash } from '@phosphor-icons/vue'
import { defineProps } from 'vue'

const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

function deleteDoc (id) {
  emit('delete', id)
}

function editSector (id) {
  emit('edit', id)
}
</script>
